<template>
  <Modal width="80%" v-model="isShowModal" :title="modalTitle">
    <DynamicFixedTable
      :view-data="newPotentialScoreList"
      :previewMode="isShowView"
      :disableMode="true"
      :perviewInfo="scoreInfo"
      :lang="lang"
      :i18="$t"
      @onChange="isShowView = false"
    />
    <Spin size="large" fix v-if="loading" />
    <div slot="footer">
      <Button
        @click="onCloseModal()"
        ><!-- 返回 -->{{ '返回' }}</Button
      >
      <Button
        type="warning"
        style="margin-left: 15px"
        @click="copyPotentialScore()"
        ><!-- 复制上年 -->{{ '复制上年' }}</Button
      >
    </div>
  </Modal>
</template>
<script>
import DynamicFixedTable from "./PotentialRangeComponents/DynamicFixedTable.vue";
export default {
  components: { DynamicFixedTable },
  data() {
    return {
      editType: "",
      editItem: {},
      isShowModal: false,
      loading: false,
      scoreInfo: {},
      isShowView: false,
      newPotentialScoreList: [],
      modalTitle:""
    };
  },
  computed: {
    lang() {
      return this.$store.getters.selectLangeData;
    },
  },
  methods: {
    copyPotentialScore() {
        this.$emit('copyData',this.newPotentialScoreList)
        this.onCloseModal()
    },

    onCloseModal() {
      this.isShowModal = false;
    },
    onEditItem(row) {
      this.editItem = JSON.parse(JSON.stringify(row));
      this.isShowModal = true;
      this.isShowView = false;
      this.modalTitle = '上年度' +
          this.$t("Potential") +
          "-" +
          this.editItem.userName +
          "/" +
          this.editItem.userEName;
      this.getData();
    },
    getData() {
      let url = "";
      let obj = {};
      url = "/achReport/searchNewPotentialScoreInfoList";
      obj = {
        id: this.editItem.id,
        isPBFlag: this.editItem.isPBFlag,
        serialnumber: this.editItem.serialnumber,
        viewLastYear: 1
      };
      this.loading = true;
      this.axios.post(url, obj).then((res) => {
        this.loading = false;
        this.newPotentialScoreList = res.newPotentialScoreList || [];
      });
    },
  },
};
</script>
<style lang="scss" scoped>
>>> .ivu-modal-body {
  height: 100% !important;
  max-height: 90%;
}
</style>



// WEBPACK FOOTER //
// src/components/process/performanceManagement/components/PotentialRangeByPre.vue